import { BugEntity, MapEntity, VisitEntity, ProjectEntity, BugNoteEntity } from "@archipad-js/archipad-model";

import WorkflowManager from '@archipad/backend/project/workflowManager';
import { isBugWorkflowEnabled } from '@archipad/backend/project/workflowManagerHelper';
import { BugError } from "@archipad/errors/errors-archipad";
import { isEmptyTempBug } from "@archipad/patchhandlers/tempEntities";
import { BugGroupEntity } from "@archipad-js/archipad-model";

/**
 * Test if the user can create a bug in this visit
 *
 * @param project current project
 * @param visit current visit
 * @param map map on which to add the map
 */
export function canCreateBug(project:ProjectEntity, bugGroup: BugGroupEntity | null): boolean {
    if (isBugWorkflowEnabled(project) ) {
        if ( ! WorkflowManager.canEnterOpenState(project, bugGroup, null)) {
            return false;
        }
    }

    return true;    // TODO: error message ?
}

/**
 * Create a new temp bug entity
 *
 * @param project current project
 * @param visit current visit
 * @param map map on which to add the map
 */
export function createTempBug(project:ProjectEntity, map:MapEntity, bugGroup: BugGroupEntity | null, visit:VisitEntity | null): BugEntity {
    const ormContext = map.getContext();
    const bug = ormContext.createEntity("Bug") as BugEntity;
    bug.project = project;
    bug.map = map;
    bug.visit = visit;
    bug.openDate = bug.visit?.date || new Date();
    bug.temp = true;
    bug.bugGroup = bugGroup;
    bug.creationDate = new Date();

    if(isBugWorkflowEnabled(project)) {
        WorkflowManager.enterOpenState(bug);
    }

    return bug;
}

/**
 * Map a temp bug concrete
 *
 * @param bug a temp bug that should be made concrete
 */
export function makeTempBugConcrete(bug: BugEntity): void {
    if (!bug.temp)
        throw new BugError(`Bug ${bug.id} is not temp`);
    if (!bug.map)
        throw new BugError(`Bug ${bug.id} is detached`);


    // find the last index (note that we loop over all map bugs, including the closed ones)
    const map: MapEntity = bug.map;
    const bugsWithSafeIndex = map.bugs
        // Filter by bug group
        .filter(b => b.bugGroup === bug.bugGroup)
        // Filter invalid bug index (NaN)
        .filter(b => Number.isFinite(b.index));

    const index = Math.max(0, ...bugsWithSafeIndex.map(b => Math.ceil(b.index)));

    // assign the bug index
    bug.index = index + 1;
    bug.temp = false;
}

export function deleteIfEmptyBug(bug: BugEntity): void {
    if ( bug && isEmptyTempBug(bug)){
        removeBug(bug);    // remove temp bug
    }
}

export function removeBug(bug: BugEntity): void {
    if(bug && !bug.isDeleted()) {
        bug.getContext().deleteEntity(bug);
    }
}

export function deleteDuplicatedTempBugs(bug: BugEntity): void{
    const mapBugs = bug.map.bugs;
    const duplicatedTempBugs = mapBugs.filter((mapBug) => {
        return mapBug !== bug && mapBug.temp === true;
    });
    for (const duplicatedTempBug of duplicatedTempBugs) {
        deleteIfEmptyBug(duplicatedTempBug);
    }
}

export function isCreationNote (bugNote: BugNoteEntity): boolean {
    return bugNote.bugTransition && bugNote.bugTransition.startState == null;
}
